import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid, TextField } from '@material-ui/core';
import HighlightableTextField from '../HighlightableTextField';
import { Field } from 'formik';
import helpers, { labelObrigatoriedade } from 'app/utils/helpers';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Skeleton from '../Skeleton';
import HighlightableCheckbox from '../HighlightableCheckbox';
import requestEndpoints from '../../../api/services/requestEndpoints';
import { STATUS_CODES } from '../../../config/status';

function OwnerOperator(props) {
    const {
        classes,
        loadingDetran,
        values,
        errors,
        setFieldValue,
        contextProps: { isInternalForm },
        campoDiferenteDoOriginal,
        highlightEnabled,
        isFieldDisabled,
        requiredFields,
    } = props;

    const activeCompany = useSelector((state) => state.company.activeCompany);
    const registrationUserInfo = useSelector((state) => state.auth.registrationInfo);
    const internalNewRequest = useSelector((state) => state.forms.internalNewRequest);
    const request = useSelector((state) => state.requests.details);

    const [nmOperador, setNmOperador] = useState(registrationUserInfo.nmUsuario);

    const [isOwner, setIsOwner] = useState(false);
    const [ownerName, setOwnerName] = useState('');
    const [ownerDocument, setOwnerDocument] = useState('');

    // Correção 369561: checkbox "operador como proprietário" não funciona corretamente nas análises.
    // a causa é a activeCompany não ser definida nestes fluxos.
    // como defini-la tem consequências imprevisíveis, pedirei os dados do operador diretamente.
    const [operador, setOperador] = useState({ nome: null, cpfCnpj: null });
    useEffect(() => {
        const emAnalise = request?.cdSituacao === STATUS_CODES.EM_ANALISE;
        if (emAnalise && isInternalForm) {
            (async () => {
                const response = await requestEndpoints.dadosOperador(request.cdSolicitacao);
                if (response && response.status === 200 && response.data) {
                    const { nome, cpfCnpj } = response.data;
                    setOperador({ nome, cpfCnpj });
                }
            })();
        }
        // eslint-disable-next-line
    }, [request]);

    const handleChangeOperator = (e, values, setFieldValue) => {
        if (isFieldDisabled('boProprietario')) {
            return;
        }
        const checked = e.target.checked;
        let ownerName = '';
        let ownerDocument = '';
        if (checked) {
            if (internalNewRequest && Object.keys(internalNewRequest).length > 0) {
                let baseData = { ...internalNewRequest.user };
                if (internalNewRequest.company) {
                    baseData = { ...internalNewRequest.company };
                }
                ownerName = baseData.deRazaoSocial || baseData.nmCompleto || baseData.nmUsuario;
                ownerDocument = baseData.deCpf || baseData.deCpfCnpj || baseData.deCnpjMatriz;
            } else {
                if (isInternalForm) {
                    const json = JSON.parse(request.jsonSolicitacao);
                    if (json.vistoriaVeiculos) {
                        const vehi = json.vistoriaVeiculos.filter((vv) => vv.cdVeiculo === values.cdVeiculo);
                        if (vehi && vehi.length > 0) {
                            ownerName = vehi[0].veiculo?.nmOperador || '';
                            ownerDocument = vehi[0].veiculo?.cdUsuario || '';
                        }
                    } else if (request.cdSituacao === STATUS_CODES.EM_ANALISE) {
                        ownerName = operador.nome ?? '';
                        ownerDocument = operador.cpfCnpj ?? '';
                    }
                } else {
                    ownerDocument = activeCompany?.deCnpjMatriz
                        ? activeCompany?.deCnpjMatriz
                        : registrationUserInfo.deCpfCnpj;
                    ownerName = activeCompany?.deRazaoSocial
                        ? activeCompany?.deRazaoSocial
                        : registrationUserInfo.nmUsuario;
                }
            }
        }

        setIsOwner(checked);
        setFieldValue('boProprietario', checked);
        handleOwnerDocument(ownerDocument, setFieldValue);
        if (!isFieldDisabled('nmProprietario')) {
            handleOwnerName(ownerName, setFieldValue);
        }
    };

    const handleOwnerName = (v, setFieldValue) => {
        setOwnerName(v);
        setFieldValue('nmProprietario', v);
    };

    const handleOwnerDocument = (v, setFieldValue) => {
        const number = helpers.formatarDocumento(v);
        setOwnerDocument(number);
        setFieldValue('deCpfCnpjProprietario', v);
    };

    const validateDocument = (value) => {
        let error;
        if (!helpers.validateCpfCnpj(value)) {
            error = 'Documento inválido';
        }
        return error;
    };

    useEffect(() => {
        if (values.boProprietario) {
            setIsOwner(values.boProprietario);
        }
        if (values.nmProprietario) {
            setOwnerName(values.nmProprietario);
        } else {
            setOwnerName('');
        }
        if (values.deCpfCnpjProprietario) {
            setOwnerDocument(helpers.formatarDocumento(values.deCpfCnpjProprietario));
        } else {
            setOwnerDocument('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingDetran, values.nmProprietario]);

    useEffect(() => {
        (() => {
            let nmOperadorTemp = '';
            if (activeCompany?.deRazaoSocial) nmOperadorTemp = activeCompany.deRazaoSocial;
            if (values?.nmOperador) nmOperadorTemp = values.nmOperador;
            if (internalNewRequest && Object.keys(internalNewRequest).length > 0) {
                let baseData = _.cloneDeep(internalNewRequest.user);
                if (internalNewRequest.company) {
                    baseData = _.cloneDeep(internalNewRequest.company);
                }
                nmOperadorTemp = baseData.deRazaoSocial || baseData.nmCompleto || baseData.nmUsuario;
            }
            if (values.content?.nmOperador) nmOperadorTemp = values.content.nmOperador;
            if (nmOperadorTemp) setNmOperador(nmOperadorTemp);
        })();
    }, [activeCompany, internalNewRequest, values]);

    return (
        <>
            <Grid item xs={12} sm={6}>
                <Field
                    name="nmOperador"
                    label={`Operador${labelObrigatoriedade('nmOperador', requiredFields)}`}
                    variant="filled"
                    margin="dense"
                    value={nmOperador}
                    disabled={isFieldDisabled('nmOperador')}
                    fullWidth
                    error={!!errors.nmOperador}
                    helperText={errors.nmOperador ? errors.nmOperador : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 90,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4} className={classes.verticalMiddle}>
                <Skeleton shouldDisplayChildren={!loadingDetran} transparent>
                    <FormControlLabel
                        className={classes.filterLabel}
                        onChange={(e) => handleChangeOperator(e, values, setFieldValue)}
                        onFocus={(event) => event.stopPropagation()}
                        disabled={isFieldDisabled('boProprietario') || loadingDetran}
                        control={
                            <HighlightableCheckbox
                                checked={isOwner}
                                isHighlightedFunction={campoDiferenteDoOriginal('boProprietario')}
                                safeToHighlight={highlightEnabled}
                            />
                        }
                        label="Operador(a) é proprietário(a) do veículo?"
                    />
                </Skeleton>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Skeleton shouldDisplayChildren={!loadingDetran} transparent>
                    <Field
                        name="nmProprietario"
                        label={`Proprietário${labelObrigatoriedade('nmProprietario', requiredFields)}`}
                        variant="filled"
                        value={ownerName}
                        disabled={isFieldDisabled('nmProprietario') || loadingDetran || isOwner}
                        fullWidth
                        error={!!errors.nmProprietario}
                        helperText={errors.nmProprietario ? errors.nmProprietario : ''}
                        onChange={(e) => handleOwnerName(e.target.value, setFieldValue)}
                        as={HighlightableTextField}
                        isHighlightedFunction={campoDiferenteDoOriginal('nmProprietario')}
                        safeToHighlight={highlightEnabled}
                        inputProps={{
                            maxLength: 90,
                        }}
                    />
                </Skeleton>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Skeleton shouldDisplayChildren={!loadingDetran} transparent>
                    <Field
                        name="deCpfCnpjProprietario"
                        label={`CPF/CNPJ${labelObrigatoriedade('deCpfCnpjProprietario', requiredFields)}`}
                        variant="filled"
                        value={ownerDocument}
                        fullWidth
                        error={!!errors.deCpfCnpjProprietario}
                        disabled={isFieldDisabled('deCpfCnpjProprietario') || loadingDetran || isOwner}
                        helperText={errors.deCpfCnpjProprietario ? errors.deCpfCnpjProprietario : ''}
                        onChange={(e) => handleOwnerDocument(e.target.value, setFieldValue)}
                        as={HighlightableTextField}
                        isHighlightedFunction={campoDiferenteDoOriginal('deCpfCnpjProprietario')}
                        safeToHighlight={highlightEnabled}
                        inputProps={{
                            maxLength: 18,
                        }}
                        validate={validateDocument}
                    />
                </Skeleton>
            </Grid>
        </>
    );
}

export default OwnerOperator;
